import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Enregistrer ScrollTrigger comme plugin
gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.defaults({
    toggleActions: 'play none none none', // Déclenchement unique
    start: 'top 80%', // Position par défaut du déclencheur
    immediateRender: false,
});

// Fonction pour gérer le modal de recherche
function initSearchModal() {
    const searchModal = document.getElementById('search-modal');
    const searchToggle = document.getElementById('search-modal-toggle');
    const searchOverlay = document.querySelector('.search-modal-overlay');
    const body = document.body;

    if (!searchModal || !searchToggle || !searchOverlay) return; // Vérification de la présence des éléments

    // Ouvrir le modal et bloquer le scroll
    searchToggle.addEventListener('click', () => {
        searchModal.classList.add('visible');
        body.classList.add('modal-open'); // Bloque le scroll
    });

    // Fermer le modal en cliquant sur l'overlay
    searchOverlay.addEventListener('click', () => {
        closeSearchModal();
    });

    // Fermer le modal avec la touche "Échap"
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchModal.classList.contains('visible')) {
            closeSearchModal();
        }
    });

    // Fonction pour fermer le modal
    function closeSearchModal() {
        searchModal.classList.remove('visible');
        body.classList.remove('modal-open'); // Débloque le scroll
    }
}

// Fonction pour initialiser les animations GSAP
function initGSAPAnimations() {
    document.querySelectorAll('.animate-fade-in').forEach((el) => {
        const duration = parseFloat(el.dataset.duration) || 1; // Durée par défaut : 1s
        const delay = parseFloat(el.dataset.delay) || 0; // Pas de délai par défaut

        gsap.from(el, {
            autoAlpha: 0,
            delay,
            duration,
            ease: 'power0',
            scrollTrigger: {
                trigger: el, // Chaque élément a son propre déclencheur
            },
        });
    });

    document.querySelectorAll('.animate-slide-bottom').forEach((el) => {
        const duration = parseFloat(el.dataset.duration) || 1; // Durée par défaut : 1s
        const delay = parseFloat(el.dataset.delay) || 0; // Pas de délai par défaut

        gsap.from(el, {
            y: 50,
            delay,
            duration,
            ease: 'power0',
            scrollTrigger: {
                trigger: el, // Chaque élément a son propre déclencheur
            },
        });
    });

    document.querySelectorAll('.wpb_video_wrapper').forEach((el) => {
        const duration = parseFloat(el.dataset.duration) || 3; // Durée par défaut : 1s

        gsap.fromTo(el,
            { width: '70%' }, // État initial
            {
                width: '100%', // État final
                duration,
                ease: 'power0',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 80%', // L'animation démarre lorsque 80% de l'élément entre dans le viewport
                    end: 'bottom 90%', // L'animation se termine lorsque le haut de l'élément atteint 20% du viewport
                    scrub: true, // Animation fluide liée au scroll
                }
            }
        );
    });
}

function initAnimatedSection() {
    const animatedSections = document.querySelectorAll('.section-animated');

    animatedSections.forEach((section) => {
        const elements = section.querySelectorAll('.fade-in');

        gsap.from(elements, {
            autoAlpha: 0, // Commence invisible
            duration: 1, // Durée de l'animation pour chaque élément
            ease: 'power3.out', // Fonction d'accélération fluide
            stagger: 0.3,
            scrollTrigger: {
                trigger: section, // L'animation commence lorsque la section entre dans le viewport
            },
        });
    });
}

function initBackgroundReveal() {
    gsap.to('.column-with-bg .vc_column-inner', {
        clipPath: 'inset(0 0 0% 0)', // Révèle l'image complètement
        duration: 5,
        ease: 'power0',
        scrollTrigger: {
            trigger: '.column-with-bg',
            start: 'top 80%',
            end: 'top 20%',
            scrub: true,
        },
    });
}

function initHeroAnimation() {
    // Animation complexe de mouvement et rotation
    gsap.to('.container-bg', {
        x: '+=50', // Déplacement horizontal
        y: '+=30', // Déplacement vertical
        rotation: 5, // Légère rotation
        duration: 5, // Durée de chaque cycle d'animation
        ease: 'power1.inOut', // Transition fluide
        repeat: -1, // Répétition infinie
        yoyo: true, // Mouvement aller-retour
    });

    // Variation d'opacité pour ajouter de la subtilité
    gsap.to('.container-bg', {
        opacity: 0.15, // Diminue légèrement l'opacité
        duration: 3,
        ease: 'power1.inOut',
        repeat: -1,
        yoyo: true,
    });

    // Zoom subtil pour un effet de profondeur
    gsap.to('.container-bg', {
        scale: 1.15, // Légère mise à l'échelle
        transformOrigin: 'center center', // Centre de l'image
        duration: 15,
        ease: 'power1.inOut',
        repeat: -1,
        yoyo: true,
    });
}

// Initialisation des scripts
document.addEventListener('DOMContentLoaded', () => {
    initSearchModal(); // Initialise le comportement du modal
    initGSAPAnimations(); // Initialise toutes les animations GSAP
    initAnimatedSection();
    initBackgroundReveal();
    initHeroAnimation();
});